import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import apiClient from "../../utils/apiClient";
import WTDTable from "./WTDTable";
import MTDTable from "./MTDTable";
import YTDTable from "./YTDTable";
import { largeDummyData } from "./dummyData";
import { alpha50Data } from "./Alpha50Data";
import { alpha100Data } from "./Alpha100Data";
import { alpha200Data } from "./Alpha200Data";
import { alpha500Data } from "./Alpha500Data";
// import { alphaNdxData } from "./AlphaNdxData";
import { alphaSnpData } from "./AlphaSnpData";

// const livePercentageData = finalData;

const alphaMapping = {
  Alpha_nifty_50: { label: "Alpha_nifty_50", data: alpha50Data },
  Alpha_nifty_100: { label: "Alpha_nifty_100", data: alpha100Data },
  Alpha_nifty_200: { label: "Alpha_nifty_200", data: alpha200Data },
  Alpha_nifty_500: { label: "Alpha_nifty_500", data: alpha500Data },
  // Alpha_nasdaq_100: { label: "Alpha_nasdaq_100", data: alphaNdxData },
  Alpha_snp_500: { label: "Alpha_snp_500", data: alphaSnpData },
};

export default function DataVisualizer() {
  const [liveData, setLiveData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState("Alpha_nifty_100");
  const [selectedStrategy, setSelectedStrategy] = useState(0);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedYTD, setSelectedYTD] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleTabClick = (key) => {
    setLiveData(alphaMapping[key].data);
    setSelectedIndex(key);
    setSelectedStrategy(0);
    setSelectedYear(null);
    setSelectedYTD(null);
    setSelectedMonth(null);
  };
  

  const handleYearClick = (year, strategyIndex) => {
    setSelectedYear(year);
    setSelectedStrategy(strategyIndex);
    setSelectedYTD(null);
    setSelectedMonth(null); // Reset selected month when changing year
  };

  const handleYTDClick = (year, ytdValue, idx) => {
    setSelectedYTD({ year, ytdValue });
    setSelectedMonth(null); // Reset selected month when selecting YTD
    setSelectedStrategy(idx);
  };

  const handleMTDClick = (year, month, idx) => {
    setSelectedYear(year);
    setSelectedMonth(month);
    setSelectedStrategy(idx);
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const mapped = alphaMapping[selectedIndex]?.data ?? [];
        setLiveData(mapped);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchData();
  }, [selectedIndex]);

  const data = liveData[selectedIndex];

  const filteredWTDs = data?.map((d) => ({
    strategy: d.strategy,
    ytds: d.ytds.filter((item) => item.year === selectedYTD?.year),
  }));

  console.log("filtered wtds", filteredWTDs);
  console.log("data is", data);

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full max-h-screen">
        <div className="flex items-center justify-between space-x-4 ">
          <div className="flex justify-between bg-[#0F0F0F] h-[60px] px-6 w-full">
            <p className="flex items-center text-lg font-semibold text-white">
              Monitor/Tracking Wall
            </p>
          </div>
        </div>

        <div className="w-full h-[calc(100vh-70px)]  text-white ">
          <div className="flex mx-auto space-x-3 mb-2 px-6 py-[8px]">
            {Object.keys(alphaMapping).map((key) => (
              <button
                key={key}
                onClick={() => handleTabClick(key)}
                className={`py-1 px-4 font-medium ${
                  key === selectedIndex
                    ? "bg-amber-700 text-white"
                    : "bg-zinc-700/80 text-white"
                } rounded`}
              >
                {alphaMapping[key].label}
              </button>
            ))}
          </div>


          {selectedMonth ? (
            <WTDTable
              selectedIndex={selectedIndex}
              data={data.find(
                (item) => item.strategy === data[selectedStrategy].strategy
              )}
              filteredWTDs={filteredWTDs}
              year={selectedYear} // Pass the selected year
              month={selectedMonth}
              onBack={() => {
                setSelectedMonth(null);
              }}
              onMTDClick={handleMTDClick}
              selectedStrategy={selectedStrategy}
            />
          ) : selectedYTD ? (
            <MTDTable
              data={data.find(
                (item) => item.strategy === data[selectedStrategy].strategy
              )}
              completeData={data}
              year={selectedYTD.year}
              onBack={() => {
                setSelectedYTD(null);
                setSelectedYear(null);
              }}
              onMTDClick={handleMTDClick} // Pass the MTD click handler
              selectedStrategy={selectedStrategy}
            />
          ) : data && data?.length > 0 ? (
            <YTDTable
              data={data}
              selectedStrategy={selectedStrategy}
              onStrategyClick={setSelectedStrategy}
              onYearClick={handleYearClick}
              onYTDClick={handleYTDClick}
            />
          ) : (
            <div>Loading ....</div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
